import { formValueSelector } from 'redux-form';
import { getEncodedParams } from 'helpers/encodeParams';

export const entitiesEndpoint = state => `${state.config.apiUrl}/v1/entities`;

export const entityMetaEndpoint = (state, payload) => (
    `${state.config.apiUrl}/v1/entity/${payload.entityId}/meta`
);

export const entityMetaSocialEndpoint = (state, payload) => {
    const { start, end } = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${payload.entityId}/meta/social?start=${start}&end=${end}`;
};

export const getEntityDataRangeEndpoint = (state, payload) => (
    `${state.config.apiUrl}/v1/entity/${payload.entityId}/meta/data-range`
);

export const updateEntityEndpoint = (state, payload) => (
    `${state.config.apiUrl}/v1/entities/${payload.entityId}`
);
export const updateEntityBrandingEndpoint = (state, payload) => (
    `${state.config.apiUrl}/v1/entities/${payload.entityId}/branding`
);
export const updateEntityATVLabCSVEndpoint = (state, payload) => (
    `${state.config.apiUrl}/v1/entities/${payload.entityId}/labs`
);
export const getEntityATVLabDataEndpoint = (state, payload) => (
    `${state.config.apiUrl}/v1/entity/${payload.entityId}/cross-channel?refresh=${payload.refresh}`
);
export const getEntityEndpoint = (state, payload) => (
    `${state.config.apiUrl}/v1/entities/${payload.entityId}`
);
export const getEntityChildrenEndpoint = (state, payload) => (
    `${state.config.apiUrl}/v1/entities/${payload.entityId}/children`
);
export const getEntityDebugHierarchyEndpoint = (state, payload) => (
    `${state.config.apiUrl}/v1/entity/${payload.entityId}/debug/hierarchy`
);
export const getUnicornGraphQLEndpoint = state => `${state.config.apiUrl}/v1/unicorn/graphql`;

export const getCurrentEntityId = state => state.entities.meta.id;
export const getCurrentEntityName = state => state.entities.meta.name;
export const getCurrentEntityMeta = state => state.entities.meta;

export const getEditFormFieldValue = formValueSelector('editEntity');
export const getCreateFormFieldValue = formValueSelector('createEntity');



// WEBPACK FOOTER //
// ./src/services/entities/selectors.js